export const TERMS_OF_USE = 'https://efood.dev/policy.pdf';
